import { connect } from 'react-redux';
import { compose } from 'recompose';

import {
  selectProgressVisitType,
  selectInsuranceErrorModalState,
  selectInsuranceErrorModalEntity,
  selectCheckInsuranceEligibilityError,
} from '../../../../redux/appointmentForm/selectors';
import { selectUpdatePatientInsuranceError } from '../../../../redux/manage-insurances/selectors/update-patient-insurance';

const mapStateToProps = state => ({
  visitType: selectProgressVisitType(state),
  entity: selectInsuranceErrorModalEntity(state),
  isOpened: selectInsuranceErrorModalState(state),
  error:
    selectCheckInsuranceEligibilityError(state) ||
    selectUpdatePatientInsuranceError(state),
});

export const enhance = compose(connect(mapStateToProps));



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/InsuranceDetails/HandleErrorCheckProfileInsuranceModal/enhance.js